import styled from "styled-components";

export const SimpleTableInner = styled.table`
	width: 100%;
	margin-bottom: 2em;
`;
